<div class="modal-header">
    <h5 class="modal-title" i18n>Driver status</h5>

    <button (click)="close()" type="button" class="close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">

    <ng-container *ngIf="driver && route">

    {{driver.name}} - Tur {{route.trip}}
    </ng-container>

    <ng-container *ngIf="grouped && grouped['Pending']">
        <p class="h4">På lastbil</p>
        <app-shipping-system-table [shipments]="grouped['Pending']"></app-shipping-system-table>
    </ng-container>
    <ng-container *ngIf="grouped && grouped['Completed']">
        <p class="h4">Afleveret</p>
        <app-shipping-system-table [shipments]="grouped['Completed']"></app-shipping-system-table>
    </ng-container>
</div>

<div class="modal-footer">

</div>
